import { MeetingSubTabs } from '@/features/meeting/MeetingSubTabs';

interface MoneyTabsProps {
  meetingId: string;
}

export function MoneyTabs({ meetingId }: MoneyTabsProps) {
  const base = `/meetings/${meetingId}`;

  return (
    <MeetingSubTabs
      ariaLabel="정산 하위 탭"
      items={[
        { to: `${base}/expense`, label: '쓴 돈', icon: 'receipt' },
        { to: `${base}/settlement`, label: '정산', icon: 'wallet' },
      ]}
    />
  );
}
